/* TDOG chat widget theming.
 *
 * Shopify's AI chat (<shopify-chat>) renders in nested OPEN shadow roots, so
 * theme CSS can't reach its internals — but JS can. This script:
 *   1. Sets the widget's public --shopify-agent-* CSS variables on the host.
 *   2. Recolors the Shop "Sign in" pill from Shop-purple to brand charcoal.
 *   3. Solidifies the frosted-glass panel (translucent background + blur)
 *      into opaque brand cream.
 * A MutationObserver re-applies everything whenever the widget re-renders.
 * Every step is defensive: if Shopify changes the internals, this silently
 * does nothing rather than breaking the chat.
 */
(function () {
  'use strict';

  var CREAM = '#f7efdf';
  var CHARCOAL = '#171614';

  function styleHost(chat) {
    try {
      chat.style.setProperty('--shopify-agent-accent-bg-color', CHARCOAL);
      chat.style.setProperty('--shopify-agent-accent-text-color', CREAM);
      chat.style.setProperty('--private-bg-blur-soft', '0px');
      chat.style.setProperty('--private-bg-blur', '0px');
    } catch (e) { /* noop */ }
  }

  function fixTree(root) {
    if (!root || !root.querySelectorAll) return;
    var els = root.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      try {
        var rect = el.getBoundingClientRect();
        if (rect.height > 200 && rect.width > 200) {
          var cs = getComputedStyle(el);
          var m = cs.backgroundColor.match(/rgba\(\d+, \d+, \d+, (0?\.\d+)\)/);
          if (m && parseFloat(m[1]) > 0.3) {
            el.style.setProperty('background-color', CREAM, 'important');
          }
          if (cs.backdropFilter && cs.backdropFilter !== 'none') {
            el.style.setProperty('backdrop-filter', 'none', 'important');
            el.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
          }
        }
        if (el.tagName === 'SHOPIFY-SIGN-IN-BUTTON' && el.shadowRoot) {
          var pill = el.shadowRoot.querySelector('button, a');
          if (pill) {
            pill.style.setProperty('background-color', CHARCOAL, 'important');
            pill.style.setProperty('color', CREAM, 'important');
          }
        }
        if (el.shadowRoot) {
          observeRoot(el.shadowRoot);
          fixTree(el.shadowRoot);
        }
      } catch (e) { /* keep going */ }
    }
  }

  var observedRoots = typeof WeakSet === 'function' ? new WeakSet() : null;
  var observer = null;
  var applyTimer = null;
  var chatHost = null;

  function scheduleApply() {
    if (applyTimer || !chatHost) return;
    applyTimer = setTimeout(function () {
      applyTimer = null;
      styleHost(chatHost);
      fixTree(chatHost.shadowRoot);
    }, 120);
  }

  /* MutationObservers do not cross shadow boundaries, and the widget mounts
     its runtime (and later the open panel) lazily in nested shadow roots —
     so every shadow root discovered during fixTree gets its own observation. */
  function observeRoot(root) {
    if (!root || !observer) return;
    if (observedRoots) {
      if (observedRoots.has(root)) return;
      observedRoots.add(root);
    }
    try {
      observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open'] });
    } catch (e) { /* noop */ }
  }

  function armObserver(chat) {
    chatHost = chat;
    try { observer = new MutationObserver(scheduleApply); } catch (e) { observer = null; }
    observeRoot(chat.shadowRoot);
    styleHost(chat);
    fixTree(chat.shadowRoot);
  }

  function boot() {
    var chat = document.querySelector('shopify-chat');
    if (chat && chat.shadowRoot) { armObserver(chat); return true; }
    return false;
  }

  if (!boot()) {
    var tries = 0;
    var poll = setInterval(function () {
      if (boot() || ++tries > 40) clearInterval(poll);
    }, 500);
  }
})();
